import { z } from 'zod';
import { DATE_ISO } from '@shared/validation/helpers';

/** Candidature : la date de réception ne peut pas précéder la date d’offre. */
export const CandidatureSchema = z
  .object({
    candidat_nom: z.string().trim().min(1, 'Nom du candidat requis'),
    candidat_email: z.string().trim().optional(),
    date_reception: z.string().regex(DATE_ISO, 'Date de réception invalide'),
    date_offre: z.string().regex(DATE_ISO, 'Date d’offre invalide').optional(),
    statut: z.string().min(1),
    consent_given: z.enum(['oui', 'non'], { error: 'Veuillez renseigner le consentement de collecte' }),
    consent_method: z.string().trim().min(1, 'Méthode de consentement requise'),
    consent_notes: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.date_offre && data.date_reception < data.date_offre) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['date_reception'],
        message: 'La date de réception doit être postérieure ou égale à la date de l’offre',
      });
    }
    if (data.consent_given === 'non') {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['consent_given'],
        message: 'Candidature non enregistrée : le consentement de collecte a été refusé.',
      });
    }
  });

export type CandidatureInput = z.infer<typeof CandidatureSchema>;
